import { number, shape } from "prop-types"
import GeneralReminders from "./GeneralReminders"
import useAttendeeTypes from "./hooks/useAttendeeTypes"
import useScheduledReminders from "./hooks/useScheduledReminders"

const ScheduledReminders = ({ event }) => {
  const {
    loading: attendeeTypeLoading,
    errors: attendeeTypeErrors,
    response: attendeeTypes
  } = useAttendeeTypes(event.id)

  const {
    loading: reminderLoading,
    errors: reminderErrors,
    response: reminders
  } = useScheduledReminders(event.id)

  const errors = attendeeTypeErrors || reminderErrors
  const loading = attendeeTypeLoading || reminderLoading

  return (
    <section className="max-width-center-stage">
      {errors?.length > 0 ? (
        <div className="error-alert alert">{errors[0].detail}</div>
      ) : (
        <>
          <GeneralReminders
            loading={loading}
            event={event}
            reminders={reminders}
            attendeeTypes={attendeeTypes}
          />
        </>
      )}
    </section>
  )
}

ScheduledReminders.propTypes = {
  event: shape({
    id: number.isRequired
  })
}

export default ScheduledReminders
